import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { folderService } from '../Services/FolderService';
import { Folder } from '../types';

export const fetchFolders = createAsyncThunk('folders/fetchFolders', async () => {
  return await folderService.getFolders();
});

export const createFolder = createAsyncThunk('folders/createFolder', async (payload: { name: string, description?: string }) => {
  await folderService.createFolder(payload.name, payload.description || '');
  return await folderService.getFolders();
});

export const deleteFolder = createAsyncThunk('folders/deleteFolder', async (folderId: string) => {
  await folderService.deleteFolder(folderId);
  return await folderService.getFolders();
});

export const updateFolder = createAsyncThunk('folders/updateFolder', async (payload: { id: string, name: string, description?: string }) => {
  await folderService.updateFolder(payload.id, payload.name, payload.description || '');
  return await folderService.getFolders();
});

interface FolderState {
  items: Folder[];
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
}

const initialState: FolderState = {
  items: [],
  status: 'idle',
};

const folderSlice = createSlice({
  name: 'folders',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchFolders.fulfilled, (state, action) => {
      state.items = action.payload;
      state.status = 'succeeded';
    });
    builder.addCase(createFolder.fulfilled, (state, action) => {
      state.items = action.payload;
    });
    builder.addCase(deleteFolder.fulfilled, (state, action) => {
      state.items = action.payload;
    });
    builder.addCase(updateFolder.fulfilled, (state, action) => {
      state.items = action.payload;
    });
  }
});
export default folderSlice.reducer;
